/**
 * Backend origin. Builds that serve the dashboard from a different origin
 * than the API inject VITE_OMNI_API_URL at build time; otherwise it is
 * same-origin (local dev proxy, or the Caddy front in the self-host install).
 */
export const API_BASE: string =
  (import.meta.env.VITE_OMNI_API_URL as string | undefined) ??
  (typeof window !== "undefined"
    ? `${window.location.protocol}//${window.location.host}`
    : "http://127.0.0.1:8080");

/**
 * The live socket. Same origin as the API unless VITE_OMNI_WS_URL says
 * otherwise. It defaulted to ws://127.0.0.1:8080/ws/live, so on a self-host
 * install every browser tried to open the chat socket on its own machine
 * (and the CSP refused it): chat never connected (RW-4.23).
 */
export const WS_URL: string =
  (import.meta.env.VITE_OMNI_WS_URL as string | undefined) ??
  `${API_BASE.replace(/^http/, "ws")}/ws/live`;
